import { useQuery } from "@tanstack/react-query";
import { fetchProfile } from "../api/services";

export const useProfileQuery = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ["profile"],
    queryFn: async () => {
      try {
        const data = await fetchProfile({});

        const profileData = {
          id: data?._id,
          first_name: data?.first_name || "",
          last_name: data?.last_name || "",
          email: data?.email || "",
          products: data.products || [],
          products_meta: data.products_meta,
          is_mainstack_user: true,
        };

        return profileData;
      } catch (error) {
        console.error("Error fetching profile:", error);
        throw error;
      }
    },
    enabled,
  });
};
